import React from 'react'
import Styled from 'styled-components'
// import STYLE_CONSTANTS from '~/style/constants'

const IconContainer = Styled.div`
  position: relative;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
`

const IconPosition = Styled.div`
  position: absolute;
  margin: auto;
`

const ItemIcon = ({ children }) => {
  return (
    <IconContainer>
      <IconPosition>{children}</IconPosition>
    </IconContainer>
  )
}

export default ItemIcon
